import React, { useState, useEffect } from 'react';
import { message, Spin } from 'antd';
import './infoPoblacion.css';
import { getInfPoblacion } from '../../services/perfiles/conponentesServices';

const InfoPoblacion = ({ municipioId }) => {
    const [data, setData] = useState(null);
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (municipioId) {
            fetchData();
        }

    }, [municipioId]);

    const fetchData = async () => {
        setLoading(true);
        setError('');
        try {
            const response = await getInfPoblacion(municipioId);
            if (response && response.status === 200) {
                const fetchedData = response.data[0]; // Aseguramos que estamos obteniendo el primer objeto del array
                setData(fetchedData);
            } else {
                throw new Error('Invalid response from server');
            }
        } catch (error) {
            setError('Error loading data');
        } finally {
            setLoading(false);
        }
    };

    if (loading) {
        return <Spin size="large" />;
    }

    if (error) {
        return <p style={{ color: 'red' }}>{error}</p>;
    }

    if (!data) {
        return <p>No data available</p>;
    }

    // Extraer los años y poblaciones dinámicamente
    const years = Object.keys(data).filter(key => key.startsWith('poblacion_')).map(key => key.split('_')[1]);
    const populations = years.map(year => data[`poblacion_${year}`]);

    return (
        <div>
            <h1>1. {data.nombre_componente}</h1>
            <p>{data.descripcion}</p>
            <div className="table-container">
                <table>
                    <thead className="table-header">
                        <tr>
                            <th colSpan={years.length}>INFORMACIÓN POBLACIONAL TOTAL</th>
                        </tr>
                        <tr>
                            {years.map((year) => (
                                <th key={year}>{year}</th>
                            ))}
                        </tr>
                    </thead>
                    <tbody className="table-body">
                        <tr>
                            {populations.map((population, index) => (
                                <td key={index}>{population}</td>
                            ))}
                        </tr>
                    </tbody>
                </table>
            </div>
            <div className="percentage">
                Porcentaje de la Población Municipal frente al total Departamental 2021: {data.porc_poblacion}%
            </div>
            <p className="source">{data.fuente}</p>
        </div>
    );
};

export default InfoPoblacion;
